// extracted by mini-css-extract-plugin
export default {"NonTotalRow":"MonthlyExpenditure_NonTotalRow__Sg9gZ","TotalRow":"MonthlyExpenditure_TotalRow__htrj5"};